import { render, staticRenderFns } from "./FilaRequisicoes.vue?vue&type=template&id=4a8b555d"
import script from "./FilaRequisicoes.vue?vue&type=script&lang=js"
export * from "./FilaRequisicoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports